export async function claimReward(args) {
    const { spaceDapp, beneficiary, recipient, signer, smartAccount } = args;
    if (!spaceDapp) {
        throw new Error('SpaceDapp is not available');
    }
    return spaceDapp.baseRegistry.rewardsDistributionV2.executeCall({
        signer,
        functionName: 'claimReward',
        args: [beneficiary, recipient],
        overrideExecution: async ({ toAddress, calldata }) => {
            return smartAccount.sendUserOp({
                toAddress: toAddress,
                callData: calldata,
                signer,
                spaceId: undefined,
                functionHashForPaymasterProxy: 'unsponsored',
            });
        },
    });
}
